import {
  getMyMemberPage as publicGetMyMemberPage,
  getSiteMap as publicGetSiteMap,
} from './members-v1-santa-member-santa-member.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getMyMemberPage: MaybeContext<
  BuildRESTFunction<typeof publicGetMyMemberPage> & typeof publicGetMyMemberPage
> = /*#__PURE__*/ createRESTModule(publicGetMyMemberPage);
export const getSiteMap: MaybeContext<
  BuildRESTFunction<typeof publicGetSiteMap> & typeof publicGetSiteMap
> = /*#__PURE__*/ createRESTModule(publicGetSiteMap);

export {
  SantaMember,
  GetMyMemberPageRequest,
  Config,
  Pattern,
  AppData,
  Numbers,
  SeoData,
  PageRole,
  RequestInfo,
  GetMyMemberPageResponse,
  MemberPageResult,
  Head,
  PublicData,
  ViewedUser,
  GetSiteMapRequest,
  GetSiteMapResponse,
  GetMyMemberPageOptions,
  GetSiteMapOptions,
} from './members-v1-santa-member-santa-member.universal.js';
